import { proxyClientOptions, RestfulClient, Session, StockSymbol } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { DetailedQuotesBySymbol } from '../../entities';
import { QuotesEnvironment } from '../../environment';
import { quotesSymbolsRoutes } from './routes';
import { QuotesSymbolsTransport } from './types';

export class QuotesSymbolsRestful extends RestfulClient implements QuotesSymbolsTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(QuotesEnvironment);
    super(
      env.symbolsUrl,
      session,
      { authorizationSession: true, 'x-device-key': true },
      proxyClientOptions(undefined, 'apikey'),
    );
  }

  getDetailedQuotes = async (symbols: StockSymbol): SafePromise<DetailedQuotesBySymbol> => {
    const env = this.session.getEnvironment(QuotesEnvironment);
    const path = this.routePath(quotesSymbolsRoutes.detailedQuotes);
    const url = this.URL(path, this.withUpstreamCredentials({ symbols }, { apikey: env.symbolsKey }));
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
